import Cropper from 'cropperjs';

class ProductImageCropForIndex {
  removeCropperContainer() {
    const cropperContainers = document.querySelectorAll('.cropper-container');
    cropperContainers.forEach((cropperContainer, index) => {
      cropperContainer.remove();
    });
  }

  closeModal(wrapper: HTMLElement) {
    this.removeCropperContainer();
    // クロップが終了したことを発火
    this.getProductImageFileInput(wrapper).dispatchEvent(new Event('cropped'));
    this.cropperDiv(wrapper).style.display = 'none';
  }

  showModal(wrapper: HTMLElement) {
    this.cropperDiv(wrapper).style.display = 'block';
  }

  refreshCropper(img: HTMLImageElement) {
    const cropper = new Cropper(img, {
      aspectRatio: 1/1,
      zoomable: false
    });
    return cropper;
  }

  setCropSubmit(wrapper: HTMLElement, cropper: Cropper) {
    this.cropSubmitButton(wrapper).addEventListener('click', () => {
      if (cropper && !(cropper as any).destroyed) {
        const croppedCanvas = cropper.getCroppedCanvas({
          fillColor: '#fff'
        });
        if (croppedCanvas) {
          const dataUrl = croppedCanvas.toDataURL('image/jpeg');
          this.getCroppedImageFileInput(wrapper).value = dataUrl;
        }
        cropper.destroy();
        this.closeModal(wrapper);
        // destroyedをtrue
        (cropper as any).destroyed = true;
      }
    });
  };

  addEventToCropperDiv(wrapper: HTMLElement) {
    const cropperDiv = this.cropperDiv(wrapper);
    if (!cropperDiv) {
      return;
    }
    cropperDiv.addEventListener('open', () => {
      const files = this.getProductImageFileInput(wrapper).files;
      if (files && files[0]) {
        const file = files[0];
        const reader = new FileReader();
        reader.addEventListener('load', (e) => {
          if ((e.target as FileReader).result) {
            // モーダルを表示
            this.showModal(wrapper);
            this.cropperImg(wrapper).src = (e.target as any).result || '';
            // Cropperを起動
            const cropper = this.refreshCropper(this.cropperImg(wrapper));
            // Set Close Event
            this.setCloseEventWithCropper(wrapper, cropper);
            // Set Crop submit
            this.setCropSubmit(wrapper, cropper);
          }
        });
        // 画像データを読み込む
        reader.readAsDataURL(file);
      }
    });
  }

  setCloseEventWithCropper(wrapper: HTMLElement, cropper: Cropper) {
    this.closeButton(wrapper).addEventListener('click', () => {
      if (cropper && !(cropper as any).destroyed) {
        cropper.destroy();
        this.closeModal(wrapper);
        // destroyedをtrue
        (cropper as any).destroyed = true;
      }
    });
    this.asItIsSubmitButton(wrapper).addEventListener('click', () => {
      if (cropper && !(cropper as any).destroyed) {
        cropper.destroy();
        this.closeModal(wrapper);
        // destroyedをtrue
        (cropper as any).destroyed = true;
      }
    });
  }

  cropperDiv(wrapper: HTMLElement) {
    return wrapper.querySelector('#store_product_cropper') as HTMLElement;
  }

  closeButton(wrapper: HTMLElement) {
    return wrapper.querySelector('#store_product_cropper_close') as HTMLElement;
  }

  cropperImageArea(wrapper: HTMLElement) {
    return wrapper.querySelector('#store_product_cropper_area') as HTMLElement;
  }

  cropperImg(wrapper: HTMLElement) {
    return this.cropperImageArea(wrapper).querySelector('img') as HTMLImageElement;
  }

  cropSubmitButton(wrapper: HTMLElement) {
    return wrapper.querySelector('#store_product_cropper_crop_submit') as HTMLElement;
  }

  asItIsSubmitButton(wrapper: HTMLElement) {
    return wrapper.querySelector('#store_product_cropper_as_it_is_submit') as HTMLElement;
  }

  updateStoreProductModal(wrapper: HTMLElement) {
    return wrapper.querySelector('#update_store_product_modal') as HTMLElement;
  }

  getProductImageFileInput(wrapper: HTMLElement) {
    const storeProductId = this.updateStoreProductModal(wrapper).dataset.storeProductId || '';
    return (wrapper.querySelector('#store_product_image_' + storeProductId) as HTMLInputElement);
  }

  getCroppedImageFileInput(wrapper: HTMLElement) {
    const storeProductId = this.updateStoreProductModal(wrapper).dataset.storeProductId || '';
    return (wrapper.querySelector('#cropped_image_' + storeProductId) as HTMLInputElement);
  }

  addEventForInitialize(wrapper: HTMLElement) {
    this.addEventToCropperDiv(wrapper);
  }

  initialize(wrapper: HTMLElement) {
    this.addEventForInitialize(wrapper);
  }
}

export default ProductImageCropForIndex;
